import React from 'react';
import GameTypeFilter from './GameTypeFilter';

function AllGame(props: any) {
  const { gameList, setGameModalVisible, namespace, menuWidth } = props;
  return <GameTypeFilter gameList={gameList} setGameModalVisible={setGameModalVisible} namespace={namespace} menuWidth={menuWidth} />;
}

export default AllGame;
